export default function create_set(min, max) {
    let arr = []
    for(let i = min, size = max; i < size; i++) {
        arr.push(i)
    }
    return arr
}